// extracted by mini-css-extract-plugin
module.exports = {"confirmation":"Confirmation_confirmation__3VYE-"};